export const DEFAULT_CLIENT_INDEX_PAGE_SIZE = 20
const exactIdSearchPattern = /^#([1-9]\d*)$/

export function getClientIndexPaginationMeta({ total, page, pageSize }) {
  const safePageSize = Math.max(1, Number(pageSize) || DEFAULT_CLIENT_INDEX_PAGE_SIZE)
  const lastPage = Math.max(Math.ceil(total / safePageSize), 1)
  const safePage = Math.min(Math.max(1, Number(page) || 1), lastPage)

  return {
    current_page: safePage,
    page_size: safePageSize,
    total,
    last_page: lastPage,
  }
}

export function getClientIndexPageItems(items, meta) {
  const start = (meta.current_page - 1) * meta.page_size
  return items.slice(start, start + meta.page_size)
}

export function compareIndexText(left, right) {
  return String(left ?? '').localeCompare(String(right ?? ''), undefined, {
    numeric: true,
    sensitivity: 'base',
  })
}

export function compareIndexDate(left, right) {
  const leftTime = left ? new Date(left).getTime() : 0
  const rightTime = right ? new Date(right).getTime() : 0

  return leftTime - rightTime
}

export function compareIndexNumber(left, right) {
  return Number(left ?? 0) - Number(right ?? 0)
}

export function parseIndexExactIdSearch(search) {
  const value = String(search ?? '').trim()
  const match = value.match(exactIdSearchPattern)

  if (!match) {
    return null
  }

  const id = Number(match[1])

  return Number.isSafeInteger(id) ? id : null
}
